export class InvestitorePercentuale {
  investorPiva: string;
  percentuale: number;
  constructor() {}
}
